import React from 'react'

type TProps = {
  content: string
  isPopularTreatmentTypesCarousel: boolean
}

function CardShortDescription({
  content,
  isPopularTreatmentTypesCarousel = false
}: TProps): JSX.Element {
  return (
    <p
      className={`line-clamp-3 text-sm ${
        isPopularTreatmentTypesCarousel
          ? 'h-10 overflow-hidden text-gray-700 sm:h-5'
          : 'text-gray-800'
      }`}
    >
      {content}
    </p>
  )
}

export default CardShortDescription
